(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('treatment-experience', {
            parent: 'entity',
            url: '/treatment-experience?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.treatmentExperience.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/treatment-experience/treatment-experiences.html',
                    controller: 'TreatmentExperienceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('treatmentExperience');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('treatment-experience-detail', {
            parent: 'treatment-experience',
            url: '/treatment-experience/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.treatmentExperience.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/treatment-experience/treatment-experience-detail.html',
                    controller: 'TreatmentExperienceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('treatmentExperience');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TreatmentExperience', function($stateParams, TreatmentExperience) {
                    return TreatmentExperience.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'treatment-experience',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('treatment-experience-detail.edit', {
            parent: 'treatment-experience-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience/treatment-experience-dialog.html',
                    controller: 'TreatmentExperienceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TreatmentExperience', function(TreatmentExperience) {
                            return TreatmentExperience.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('treatment-experience.new', {
            parent: 'treatment-experience',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience/treatment-experience-dialog.html',
                    controller: 'TreatmentExperienceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: null,
                                good: null,
                                improvementPotential: null,
                                summary: null,
                                published: null,
                                categoryGeneral: null,
                                categoryInformation: null,
                                categoryTimeTaken: null,
                                categoryFurnishing: null,
                                categoryCostBenefit: null,
                                categoryPainlessness: null,
                                overallRating: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('treatment-experience', null, { reload: 'treatment-experience' });
                }, function() {
                    $state.go('treatment-experience');
                });
            }]
        })
        .state('treatment-experience.edit', {
            parent: 'treatment-experience',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience/treatment-experience-dialog.html',
                    controller: 'TreatmentExperienceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TreatmentExperience', function(TreatmentExperience) {
                            return TreatmentExperience.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('treatment-experience', null, { reload: 'treatment-experience' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('treatment-experience.delete', {
            parent: 'treatment-experience',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience/treatment-experience-delete-dialog.html',
                    controller: 'TreatmentExperienceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TreatmentExperience', function(TreatmentExperience) {
                            return TreatmentExperience.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('treatment-experience', null, { reload: 'treatment-experience' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
